import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaLongArrowAltRight } from "react-icons/fa";

const BarBalance = () => {
  const [TrOutletId, setOutlet] = useState(null);
  const [barBalanceData, setBarBalanceData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(""); // user-selected date
  const [queryDate, setQueryDate] = useState(null); // confirmed query date

  const apiUrl = process.env.REACT_APP_SERVER_API;

  // Initialize on mount
  useEffect(() => {
    const selectedOutlet = JSON.parse(localStorage.getItem("SelectedOutlet"));
    if (selectedOutlet) {
      setOutlet(selectedOutlet);
    }

    const today = new Date().toISOString().split("T")[0];
    setSelectedDate(today);
  }, []);

  const getFoodItemSale = async (date) => {
    if (!TrOutletId || !date) return;
    try {
      const resp = await axios.get(
        `${apiUrl}rptBarBalance?outletId=${TrOutletId.outlate_id}&trdt=${date}`
      );
      setBarBalanceData(resp.data.data || []);
      console.log("✅ Data fetched for", date);
    } catch (error) {
      console.error("❌ Error fetching data:", error);
    }
  };

  const handleShowClick = () => {
    if (selectedDate) {
      setQueryDate(selectedDate);
      getFoodItemSale(selectedDate);
    }
  };

  const changeDate = (offset) => {
    if (!selectedDate) return;
    const newDate = new Date(selectedDate);
    newDate.setDate(newDate.getDate() + offset);
    setSelectedDate(newDate.toISOString().split("T")[0]);
  };

  const totalGdwnQty = barBalanceData.reduce((sum, item) => sum + (item.GdwnQty || 0), 0);
  const totalCntrQty = barBalanceData.reduce((sum, item) => sum + (item.CntrQty || 0), 0);
  
 

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-md-12'>

          <div className='mt-3 col-md-3'>
            <div className='d-flex'>
              <input
                type="date"
                className='form-control me-3'
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
              <button className='btn btn-primary' onClick={handleShowClick}>Show</button>
            </div>

            <div className='mt-2'>
              <button className='btn btn-success me-2' onClick={() => changeDate(-1)}>Prev</button>
              <button className='btn btn-success' onClick={() => changeDate(1)}>Next</button>
            </div>
          </div>

          <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '600px', maxWidth: '100%' }}>
            <table className="table table-bordered mt-4">
              <thead className='table-light sticky-top'>
                <tr>
                  <th className='border'>Item Name</th>
                  <th className='border text-end'>GdwnQty</th>
                  <th className='border text-end'>CntrQty</th>
                 
                </tr>
              </thead>
              <tbody>
                {barBalanceData.length > 0 ? (
                  barBalanceData.map((item) => (
                    <tr key={item._id}>
                      <td className='border'>{item.ItemName}</td>
                      <td className='border text-end'>{item.GdwnQty}</td>
                      <td className='border text-end'>{item.CntrQty}</td>
                    
                     
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className='text-center'>No records found</td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td className='border text-end'><strong>Total <FaLongArrowAltRight /></strong></td>
               
                  <td className='border text-end'><strong>{totalGdwnQty.toFixed(2)}</strong></td>
                  <td className='border text-end'><strong>{totalCntrQty.toFixed(2)}</strong></td>
                  
                </tr>
              </tfoot>
            </table>
          </div>

        </div>
      </div>
    </div>
  );
};

export default BarBalance;
